import { administracionAccionesRoles } from '../../acciones-roles/administracion/administracion-acciones-roles';
import { SideBarButton } from '../../nav-list/recursive-sidebar/class/sidebar';
import {
  PreConfigButton1,
  PreConfigButton3,
} from '../../nav-list/recursive-sidebar/configuration/preconfig';

export const ManagementRoutes: SideBarButton = {
  data: {
    name: 'Administracion',
  },
  options: PreConfigButton1,
  icon: 'dataset',
  butons: [
    {
      data: {
        name: 'Gestion',
        url: '/management',
        exact: true,
        roles: [...administracionAccionesRoles.sideNavActions.filterList],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Agregar numero de parte',
        url: '/management/import/assembly-item',
        exact: true,
        roles: [...administracionAccionesRoles.sideNavActions.userList],
      },
      options: PreConfigButton3,
    },
  ],
};
